import AppConfig from '../../app-config.json';
import TimeoutWarningComponent from './timeout-warning-component';
import TimeoutWarningModal from './timeout-warning-modal/timeout-warning-modal';
import TimeoutWarningService from './timeout-warning-service';
import ngIdle from 'ng-idle';

/***
 *  A component used for presenting the user with an idling message and logging them out if they idle on the site
 *  for too long.
 */
const timeoutWarning = angular
    .module('FacilityData.Common.TimeoutWarning', [
        ngIdle,
        TimeoutWarningModal
    ])
    .component('timeoutWarning', TimeoutWarningComponent)
    .service('TimeoutWarningService', TimeoutWarningService)
    .constant('appConfig', AppConfig)
    .config((
        KeepaliveProvider,
        appConfig
    ) => {
        'ngInject';
        // Every 10 minutes, as long as the user isn't Idle, send a keepalive request to make sure the user stays
        // authenticated on the server.
        KeepaliveProvider.http(appConfig.apiUrl + '/users/current/')
    })
    .run((
        Idle,
        CurrentUser,
        TimeoutWarningService
    ) => {
        'ngInject';
        Idle.setIdle(TimeoutWarningService.autoLogoutIdleTime);
        Idle.setTimeout(TimeoutWarningService.autoLogoutTimeoutTime);
        // Only start watching for user idling if the user is already logged in.
        CurrentUser.updateCurrentUser().then(() => {
            if (CurrentUser.isLoggedIn()) {
                Idle.watch();
            }
        })
    })
    .name;

export default timeoutWarning;


// WEBPACK FOOTER //
// ./app/common/timeout-warning/timeout-warning.js